import { createContext } from 'react';

import { DEFAULT_DEADLINE, DEFAULT_SLIPPAGE } from 'utils';

export interface IContractSettingsContextType {
  deadline: number; // minutes
  slippage: number; // percents,
  updateSlippage: (slippage: number) => void;
  updateDeadline: (deadline: number) => void;
}

export const ContractSettingsContext = createContext<IContractSettingsContextType>({
  slippage: DEFAULT_SLIPPAGE,
  deadline: DEFAULT_DEADLINE,
  updateSlippage: () => {},
  updateDeadline: () => {},
});
